(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('EstadiosFenologicosEditCtrl', EstadiosFenologicosEditController);

  EstadiosFenologicosEditController.$inject = [
    '$scope',
    'EstadiosFenologicosService',
    'MessagesService',
    'CommonHTTPService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function EstadiosFenologicosEditController($scope, EstadiosFenologicosService, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.estadio = null; // vem da diretiva
    vm.editEstadio = {
      id: null,
      descricao: '',
      abreviatura: '',
      ordem: null,
      tp_contagem: '',
      atividade: null
    };
    vm.loading = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.cancel = cancel;
    vm.saveEstadio = saveEstadio;

    //////////////////////////////////////////
    // Function declarations
    function getBasicData() {
      vm.editEstadio.descricao = vm.estadio.descricao;
      if (vm.estadio.atividade) {
        vm.editEstadio.atividade = _.find(vm.atividades, { id: vm.estadio.atividade.id });
      }
      vm.editEstadio.id = vm.estadio.id;
      vm.editEstadio.abreviatura = vm.estadio.abreviatura;
      vm.editEstadio.ordem = vm.estadio.ordem;
      vm.editEstadio.tp_contagem = vm.estadio.tp_contagem;
    }

    function cancel() {
      reset();
      if (!vm.estadio) {
        return $scope.$emit('cancelCreate');
      }
      $scope.$emit('cancelEdit', vm.estadio);
    }

    function reset() {
      if (!vm.estadio) {
        // Criando um novo item, então reseta os valores para quando for criar novamente
        for (const key in vm.editEstadio) {
          vm.editEstadio[key] = null;
        }
      } else {
        // Estava editando um item, volta os valores originais não alterados
        getBasicData();
      }
    }

    // eslint-disable-next-line max-lines-per-function, max-params
    function saveEstadio(event) {
      if (event) {
        preventDefault(event);
      }

      vm.loading = true;
      return EstadiosFenologicosService.save(vm.editEstadio)
        .then(() => {
          if (vm.estadio) {
            return EstadiosFenologicosService.getItem(vm.estadio.id);
          }
          return null;
        })
        .then((result) => {
          reset();
          if (result) {
            MessagesService.alert('Estádio Fenológico atualizado com sucesso!');
            return $scope.$emit('estadioUpdated', vm.estadio, result);
          }
          MessagesService.alert('Estádio Fenológico criado com sucesso!');
          $scope.$emit('estadioCreated');
        })
        .catch((error) => {
          const message = 'Erro ao salvar estádio fenológico, tente novamente.';
          console.error('Erro ao salvar estádio fenológico', error);
          MessagesService.alert(message);
        })
        .finally(() => vm.loading = false);
    }

    //////////////////////////////////////////
    // Controller logic
    const itemWatcher = $scope.$watch('edit.estadio', () => {
      itemWatcher();

      if (vm.estadio) {
        getBasicData();
      }
    });
  }
}());

